export enum TimelineStoppageType {
  STOPPED = 0,
  PAUSED = 1,
  SYSTEMSTOPPED = 2,
}
